const SET_LAST_SEEN_RELEASE_ID = 'releaseNotes/SET_LAST_SEEN_RELEASE_ID';
const SET_RELEASE_NOTES_PREFS_LOADED = 'releaseNotes/SET_PREFS_LOADED';

const initialState = {
  lastSeenRelease: null,
  prefsLoaded: false
};

const releaseNotes = (state = initialState, action) => {
  switch (action.type) {
    case SET_LAST_SEEN_RELEASE_ID:
      return {
        ...state,
        lastSeenRelease: action.payload.lastSeenRelease
      };
    case SET_RELEASE_NOTES_PREFS_LOADED:
      return {
        ...state,
        prefsLoaded: action.payload
      };
    default:
      return state;
  }
};

export default releaseNotes;

export const setLastSeenRelease = lastSeenRelease => ({
  type: SET_LAST_SEEN_RELEASE_ID,
  payload: { lastSeenRelease }
});

export const setReleaseNotesPrefsLoaded = loaded => ({
  type: SET_RELEASE_NOTES_PREFS_LOADED,
  payload: loaded
});